import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import _ from 'lodash'
import { clearFlashMessage } from '../../common/app/actions'
import { Button } from '../components'


class FlashMessage extends React.Component {
  constructor(props) {
    super(props)
    this.clearFlashMessageWithDelay = _.debounce(this.props.clearFlashMessage,
      4000, { trailing: 'true' })
  }

  render() {
    const { successMessage, errorMessage, clearFlashMessage, intl } = this.props
    if (successMessage) {
      this.clearFlashMessageWithDelay()
      return (
        <div className="flash-msg success-msg">
          <span>{intl.formatMessage(messages[successMessage])}</span>
        </div>
      )
    } else if (errorMessage) {
      return (
        <div className="flash-msg error-msg">
          <span>{intl.formatMessage(messages[errorMessage])}</span>
          <Button onClick={() => clearFlashMessage()}>
            {intl.formatMessage(messages.confirm)}
          </Button>
        </div>
      )
    }
    return null
  }
}

FlashMessage.defaultProps = {
  successMessage: '',
  errorMessage: '',
}

FlashMessage.propTypes = {
  intl: PropTypes.object.isRequired,
  clearFlashMessage: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
}

const enhance = compose(
  connect(state => ({
    successMessage: state.app.success,
    errorMessage: state.app.error,
  }), { clearFlashMessage }),
  injectIntl,
)

export default enhance(FlashMessage)

const messages = defineMessages({
  confirm: {
    id: 'flashMessage.confirm',
    defaultMessage: 'Ok',
  },
  lessonSaved: {
    id: 'flashMessage.lessonSaved',
    defaultMessage: 'Cvičenie bolo uložené.',
  },
  lessonDeleted: {
    id: 'flashMessage.lessonDeleted',
    defaultMessage: 'Cvičenie bolo vymazané.',
  },
  lessonDeleteFailUsedInTest: {
    id: 'flashMessage.lessonDeleteFailUsedInTest',
    defaultMessage: 'Cvičenie nebolo vymazané, pretože je použité v teste.',
  },
  lessonDeleteFailUsedInHomework: {
    id: 'flashMessage.lessonDeleteFailUsedInHomework',
    defaultMessage: 'Cvičenie nebolo vymazané, pretože je použité v domácej úlohe.',
  },
  lessonNotFound: {
    id: 'flashMessage.lessonNotFound',
    defaultMessage: 'Cvičenie nebolo nájdené!',
  },
  lessonNoAccess: {
    id: 'flashMessage.lessonNoAccess',
    defaultMessage: 'Cvičenie neexistuje alebo k nej nemáte prístup.',
  },
  resultNoAccess: {
    id: 'flashMessage.resultNoAccess',
    defaultMessage: 'Výsledok neexistuje alebo nemáte k nemu prístup.',
  },
  testNoAccess: {
    id: 'flashMessage.testNoAccess',
    defaultMessage: 'Test neexistuje alebo k nemu nemáte prístup.',
  },
  testAlreadyWritten: {
    id: 'flashMessage.testAlreadyWritten',
    defaultMessage: 'Test ste už vyplnili. Pre opakované vyplnenie požiadajte vyučujúceho o vymazanie pôvodného výsledku.',
  },
  homeworkNoAccess: {
    id: 'flashMessage.homeworkNoAccess',
    defaultMessage: 'Úloha neexistuje alebo k nej nemáte prístup.',
  },
  dataNoAccess: {
    id: 'flashMessage.dataNoAccess',
    defaultMessage: 'Dáta su nedostupné.',
  },
  classNotExists: {
    id: 'flashMessage.classNotExists',
    defaultMessage: 'Trieda neexistuje alebo k nej nemáte prístup!',
  },
  lessonFavoriteDeleted: {
    id: 'flashMessage.lessonFavoriteDeleted',
    defaultMessage: 'Cvičenie bolo odobrané z obľúbených.',
  },
  changesSaved: {
    id: 'flashMessage.changesSaved',
    defaultMessage: 'Zmeny boli uložené.',
  },
  testSaved: {
    id: 'flashMessage.testSaved',
    defaultMessage: 'Test bol uložený.',
  },
  testDeleted: {
    id: 'flashMessage.testDeleted',
    defaultMessage: 'Test bolo vymazaný.',
  },
  resultDeleted: {
    id: 'flashMessage.resultDeleted',
    defaultMessage: 'Výsledok bol vymazaný.',
  },
  sampleTestsCreated: {
    id: 'flashMessage.sampleTestsCreated',
    defaultMessage: 'Testy boli vytvorené.',
  },
  passwordChanged: {
    id: 'flashMessage.passwordChanged',
    defaultMessage: 'Heslo bolo zmenené.',
  },
  followSuccess: {
    id: 'flashMessage.followSuccess',
    defaultMessage: 'Uživateľ bol pridaný do zoznamu.',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/FlashMessage.js